export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5465.1715e6c7.jpg";